import { render, staticRenderFns } from "./CatalogSearchView.vue?vue&type=template&id=31145952"
import script from "./CatalogSearchView.vue?vue&type=script&lang=ts"
export * from "./CatalogSearchView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports